<template>
    <section class="central-background" style="height: 91vh">
        <LevelTwo :router="router" />
        <main class="report content report-layout card px-0 list-section mt-3 position-relative">
            <section class="w-100 h-100 py-2">
                <section class="mt-2">
                    <router-view />
                </section>
            </section>
        </main>
    </section>
</template>

<script src="./Admin.ts"></script>
